import { IconProps } from "../../../types/style";

const CopyClipboardIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.37499 9.68769C4.68441 9.68576 3.31443 8.31576 3.3125 6.6252V2.6877C3.3125 2.6002 3.31818 2.51271 3.32562 2.42871C2.52237 2.77378 2.00131 3.56347 2 4.4377V8.81269C2.00144 10.0202 2.97996 10.9988 4.18748 11.0002H6.81248C7.68671 10.9989 8.4764 10.4778 8.82149 9.67457C8.73398 9.68201 8.64998 9.68769 8.56249 9.68769H6.37499Z"
          fill={color}
        />
        <path
          d="M10.3803 1.9316L9.38108 0.899549C9.27105 0.78813 9.142 0.697301 9 0.631348V2.25009H10.6012C10.5438 2.13354 10.4694 2.02619 10.3803 1.9316Z"
          fill={color}
        />
        <path
          d="M8.5625 2.25001C8.5625 2.49164 8.75837 2.68751 8.99999 2.68751H10.7351C10.7029 2.40343 10.5782 2.13779 10.3803 1.93151L9.38107 0.899452C9.16248 0.677886 8.87248 0.540873 8.5625 0.512695V2.25001Z"
          fill={color}
        />
        <path
          d="M7.6875 2.24999V0.5H6.37501C5.16749 0.501456 4.18896 1.47999 4.1875 2.6875V6.625C4.18896 7.83252 5.16749 8.81105 6.37501 8.81251H8.56251C9.77003 8.81105 10.7486 7.83252 10.75 6.625V3.56249H9C8.27513 3.56249 7.6875 2.97488 7.6875 2.24999Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default CopyClipboardIcon;
